<template>
    <div class="container-pedido">
        <loader 
            v-if="
                isLoading || 
                contagem.loading || 
                anexo.loading || 
                pagamento.loading || 
                logs_integracao.loading
            " 
        />
        <div id="main" v-if="loadingComplete">
        
            <div class="cabecalho">
                <div class="pedido">
                    <alert-container :messages="msgs" />
                    <div class="listing-header mb-4">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{
                                    loadingComplete
                                        ? title
                                        : $t("carregando") + "..."
                                }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a
                                            @click="
                                                $router.push({
                                                    name: 'ven-pedido-list',
                                                })
                                            "
                                            >{{ $t("pedidos") }}</a
                                        >
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            loadingComplete
                                                ? title
                                                : $t("carregando") + "..."
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <div class="header-buttons">
                            <div
                                v-if="currentWorkflow"
                                class="status-circle has-background-primary has-text-white"
                                v-tippy
                                :title="getT(currentWorkflow.statuswf_title)"
                            >
                                {{ currentWorkflow.sigla }}
                            </div>
                            <span></span>
                            <button
                                class="save-btn py-0 is-flex is-flex-centered"
                                type="button"
                                @click="saveExportacao"
                            >
                                <b-icon 
                                    v-if="pedido && pedido.registro_enviado == 'ED'"
                                    class="mr-2"
                                    icon="file-export" 
                                    type="is-white"
                                    v-tippy 
                                    :title="$t('msg-botao-pdf-pedido')"
                                />
                                <b-icon v-else icon="file-export" class="mr-2"/>
                                PDF
                                <button-loader :isSaving="isExporting" />
                            </button>
                            <button
                                class="delete-btn"
                                type="button"
                                @click="
                                    $router.push(
                                        $route.query.from
                                            ? {
                                                name: $route.query.from,
                                                params: { id: $route.query.id },
                                                query: { aba: 1 }
                                            }
                                            : { name: 'ven-pedido-list' }
                                    )
                                "
                            >
                                {{ $t("voltar") }}
                            </button>
                            <button
                                class="save-btn py-0 is-flex is-flex-centered"
                                v-if="isEditSituacao"
                                type="button"
                                :disabled="statusLoading"
                                @click="saveOrInformPercent"
                            >
                                {{ $t('salvar') }}
                            </button>
                        </div>
                    </div>

                    <!-- CABEÇALHO -->
                    <div class="columns is-variable is-2 detalhes-pedido">
                        <!-- NOME, RSOCIAL, VENDEDOR, DATA CHECKIN, STATUS DO PEDIDO -->
                        <div class="column is-one-third">
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("codigo-cliente") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido && !isNull(pedido.cli_idclienteerp) ? pedido.cli_idclienteerp : ''"
                                        readonly
                                        smaller
                                        noClearfix
                                    />
                                </div>
                            </div>

                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("nome-do-cliente") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido && pedido.cliente
                                                ? pedido.cliente.nome
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("razao-social") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido && pedido.cliente
                                                ? pedido.cliente.rsocial
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("vendedor") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido ? pedido.vendedor : ''"
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("motivo") }}
                                </div>
                                <div class="column" style="font-size: 12px">
                                    <vss-select
                                        label="Motivo"
                                        :options="listMotivo"
                                        v-model="motivo"
                                        :disabled="true"
                                        :height="24"
                                        noClearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    <VerifiedLable
                                        title="tipo-autorizacao"
                                        :fontSize="16"
                                    />
                                </div>
                                <div class="column is-6" style="font-size: 12px">
                                    <vss-select
                                        ref="tipoAutorizacaoSelect"
                                        label="label"
                                        :options="tipoAutorizacaoList"
                                        :loading="tipoAutorizacaoLoading"
                                        v-model="tipoAutorizacaoSelected"
                                        @input="setTipoAutorizacaoSelected"
                                        :disabled="!isEditSituacao"
                                        :height="24"
                                        mlLabels
                                        noClearfix
                                    />
                                </div>
                            </div>
                            <div
                                class="columns is-variable is-2 is-vcentered"
                                v-if="pedido.checks && pedido.checks.idcheck > 0"
                            >
                                <div
                                    class="column detalhes-label"
                                    :class="{
                                        'has-check-photo':
                                            pedido.checks.documentos &&
                                            pedido.checks.documentos.findIndex(
                                                (e) =>
                                                    e.datahora ==
                                                    pedido.checks.checkindatahora
                                            ) > -1,
                                    }"
                                    @click="openCheckPhotoModal('in')"
                                >
                                    <b-icon
                                        v-if="
                                            pedido.checks.documentos &&
                                            pedido.checks.documentos.findIndex(
                                                (e) =>
                                                    e.datahora ==
                                                    pedido.checks.checkindatahora
                                            ) > -1
                                        "
                                        icon="camera"
                                        size="is-small"
                                    />
                                    <span>{{ $t("data-check-in") }}</span>
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido.checks &&
                                            pedido.checks.checkindatahora
                                                ? $moment(
                                                    pedido.checks.checkindatahora
                                                ).format('L LT')
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- TIPO PEDIDO, PRAZO, FORMA PGTO, DATA CHECKOUT -->
                        <div class="column is-one-third">
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("cnpj") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido && !isNull(pedido.cli_cnpjcpf) ? pedido.cli_cnpjcpf : ''"
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("tipo-pedido") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido ? pedido.tipopedido : ''"
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("prazo") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido ? pedido.prazopagamento : ''"
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("forma-pgto") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido ? pedido.formapagamento : ''"
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2">
                                <div class="column detalhes-label">
                                    {{ $t("motivo-obs") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="pedido ? pedido.motivoObservacao : ''"
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    <VerifiedLable
                                        title="motivo-autorizacao"
                                        :required="
                                            isEditSituacao &&
                                            tipoAutorizacaoSelected &&
                                            tipoAutorizacaoSelected.obrigaMotivo === 2
                                        "
                                        :fontSize="16"
                                    />
                                </div>
                                <div class="column is-6" style="font-size: 12px">
                                    <vss-select
                                        label="label"
                                        ref="motivoAutorizacaoSelect"
                                        :options="motivoAutorizacaoList"
                                        :loading="motivoAutorizacaoLoading"
                                        v-model="motivoAutorizacaoSelected"
                                        :disabled="
                                            !isEditSituacao ||
                                            (
                                                tipoAutorizacaoSelected &&
                                                tipoAutorizacaoSelected.obrigaMotivo === 0
                                            )
                                        "
                                        :required="
                                            tipoAutorizacaoSelected &&
                                            tipoAutorizacaoSelected.obrigaMotivo === 2
                                        "
                                        :invalid="
                                            tipoAutorizacaoSelected &&
                                            tipoAutorizacaoSelected.obrigaMotivo === 2 &&
                                            isNull(motivoAutorizacaoSelected)
                                        "
                                        invalidWhenDisabled
                                        :height="24"
                                        clearable
                                        noClearfix
                                    />
                                </div>
                            </div>
                            <div
                                class="columns is-variable is-2 is-vcentered"
                                v-if="pedido.checks && pedido.checks.idcheck > 0"
                            >
                                <div
                                    class="column detalhes-label"
                                    :class="{
                                        'has-check-photo':
                                            pedido.checks.documentos &&
                                            pedido.checks.documentos.findIndex(
                                                (e) =>
                                                    e.datahora ==
                                                    pedido.checks.checkoutdatahora
                                            ) > -1,
                                    }"
                                    @click="openCheckPhotoModal('out')"
                                >
                                    <b-icon
                                        v-if="
                                            pedido.checks.documentos &&
                                            pedido.checks.documentos.findIndex(
                                                (e) =>
                                                    e.datahora ==
                                                    pedido.checks.checkoutdatahora
                                            ) > -1
                                        "
                                        icon="camera"
                                        size="is-small"
                                    />
                                    <span>{{ $t("data-check-out") }}</span>
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido.checks &&
                                            pedido.checks.checkoutdatahora
                                                ? $moment(
                                                    pedido.checks.checkoutdatahora
                                                ).format('L LT')
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- DATA INCLUSÃO, DATA TRANSMISSÃO, DATA ERP, VERIFICOU QR -->
                        <div class="column is-one-third">
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("data-inclusao") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido && pedido.datahora
                                                ? $moment(pedido.datahora).format(
                                                    'L LT'
                                                )
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("data-transmissao") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido && pedido.datahorainc
                                                ? $moment(
                                                    pedido.datahorainc
                                                ).format('L LT')
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    {{ $t("data-envio-erp") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido && pedido.datahoraenvioerp
                                                ? $moment(
                                                    pedido.datahoraenvioerp
                                                ).format('L LT')
                                                : ''
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                            <!-- @85171 - Status do pedido -->
                            <div class="columns is-variable is-2 is-vcentered">
                                <div class="column detalhes-label">
                                    <VerifiedLable
                                        title="status"
                                        :required="isEditSituacao"
                                        :fontSize="16"
                                    />
                                </div>
                                <div class="column is-6" style="font-size: 12px">
                                    <vss-select
                                        ref="statusSelect"
                                        label="label"
                                        :options="listStatusPedido"
                                        :loading="statusLoading"
                                        v-model="status"
                                        :disabled="!isEditSituacao"
                                        :height="24"
                                        :required="isEditSituacao"
                                        :invalid="isEditSituacao && isNull(status)"
                                        invalidWhenDisabled
                                        noClearfix
                                    />
                                </div>
                            </div>
                            <!-- Fim Status do pedido -->
                            <div 
                                v-if="pedidoVinculado"
                                class="columns is-variable is-2 is-vcentered"
                            >
                                <div class="column detalhes-label">
                                    {{ $t("pedido-vinculado") }}
                                </div>
                                <div class="column is-5">
                                    <v-input
                                        :value="pedidoVinculado.idpedidoerp"
                                        disabled
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                                <span 
                                    class="column is-1 is-clickable pl-0"
                                    @click="goToPedidoVinculado(pedidoVinculado.idpedido)"
                                >
                                    <b-icon
                                        type="is-primary"
                                        icon="open-in-new"
                                        size="is-small"
                                        v-tippy 
                                        :title="$t('abrir-pedido-vinculado')"
                                    />
                                </span>
                            </div>
                            <div 
                                v-if="pedidosVinculadoAEssePedido.length > 0"
                                class="columns is-variable is-2 is-vcentered"
                            >
                                <div class="column detalhes-label">
                                    <VerifiedLable
                                        title="pedidos-vinculado"
                                        :fontSize="16"
                                    />
                                    <b-tooltip
                                        :label="$t('msg-pedidos-vinculado')"
                                        position="is-top"
                                        type="is-dark"
                                        multilined
                                    >
                                        <b-icon icon="information" size="is-small" />
                                    </b-tooltip>
                                </div>
                                <div class="column is-5" style="font-size: 12px">
                                    <vss-select
                                        label="label"
                                        :options="pedidosVinculadoAEssePedido"
                                        :loading="pedidosVinculadoAEssePedidoLoading"
                                        v-model="pedidosVinculadoAEssePedidoSelected"
                                        :height="24"
                                        noClearfix
                                    />
                                </div>
                                <span 
                                    class="column is-1 is-clickable pl-0"
                                    @click="goToPedidoVinculado(pedidosVinculadoAEssePedidoSelected.id)"
                                >
                                    <b-icon
                                        type="is-primary"
                                        icon="open-in-new"
                                        size="is-small"
                                        v-tippy
                                        :title="$t('abrir-pedido-vinculado')"
                                    />
                                </span>
                            </div>
                            <div
                                class="columns is-variable is-2 is-vcentered"
                                v-if="pedido.checks && pedido.checks.idcheck > 0"
                            >
                                <div class="column detalhes-label">
                                    {{ $t("verificou-qr-code") }}
                                </div>
                                <div class="column">
                                    <v-input
                                        :value="
                                            pedido.checks &&
                                            pedido.checks.verificouqrcode
                                                ? pedido.checks.verificouqrcode ==
                                                'S'
                                                    ? $t('sim')
                                                    : $t('nao')
                                                : $t('nao')
                                        "
                                        readonly
                                        smaller
                                        no-clearfix
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="listing-header">
                        <div class="title-breadcrumb"></div>
                        <div class="header-buttons">
                            <button
                                class="save-btn py-0 is-flex is-flex-centered"
                                v-if="assinatura.url_documento"
                                type="button"
                                @click="isImageAssinaturaModalActive = true"
                            >
                                {{ $t("pedido-assinatura") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4 is-flex gap-3">
                <div class="is-flex-grow-1">
                    <VerifiedLable
                        :title="'obs-pedido'"
                        :fontSize="16"
                    />
                    <v-textarea
                        :value="pedido.obspedido"
                        disabled
                        readonly
                        smaller
                        no-clearfix
                    />
                </div>
                <div class="is-flex-grow-1">
                    <VerifiedLable
                        :title="'obs-autorizacao'"
                        :required="
                            isEditSituacao &&
                            motivoAutorizacaoSelected &&
                            motivoAutorizacaoSelected.habilitaobrigaobservacao === 2"
                        :fontSize="16"
                    />
                    <v-textarea
                    v-model="pedido.motivoAprovacaoObs"
                    ref="motivoAprovacaoObsInput"
                        :required="
                            motivoAutorizacaoSelected &&
                            motivoAutorizacaoSelected.habilitaobrigaobservacao === 2"
                        :disabled="
                            (motivoAutorizacaoSelected &&
                            motivoAutorizacaoSelected.habilitaobrigaobservacao === 0) ||
                            !isEditSituacao"
                        smaller
                        :invalid="
                            motivoAutorizacaoSelected &&
                            motivoAutorizacaoSelected.habilitaobrigaobservacao === 2 &&
                            isNull(pedido.motivoAprovacaoObs)"
                    />
                </div>
                <div class="is-flex-grow-1">
                    <VerifiedLable
                        :title="'critica'"
                        :fontSize="16"
                    />
                    <v-textarea
                        :value="pedido.critica"
                        disabled
                        readonly
                        smaller
                        no-clearfix
                    />
                </div>
            </div>
            <div class="item-tabs mb-4">
                <ul class="nav nav-tabs">
                    <li
                        :class="{ active: abaAtual == i }"
                        @click="changeTab(i)"
                        :key="i"
                        v-for="(aba, i) in abas"
                    >
                        <a data-toggle="tab" href="#">{{
                            $t(aba.label)
                        }}</a>
                    </li>
                </ul>
            </div>

            <!-- ABA DE ITENS DO PEDIDO -->
            <Itens 
                v-if="loadingComplete"
                v-show="abas[abaAtual].label == 'itens'"
                :isPedidoRetorno="$route.params.origem != 'interno'"
                :pedido="pedido"
                :isEditSituacao="isEditSituacao"
            />

            <!-- aba status wf -->

            <StatusWf
                v-if="loadingComplete"
                v-show="abas[abaAtual].label == 'status-wf'"
                :pedido="pedido"
                @current-workflow="currentWorkflow = $event"
                height="100%"
            />

            <!-- ABA DE CONTAGEM -->
            <div
                class="tab-content"
                v-show="abas[abaAtual].label == 'contagem'"
            >
                <div
                    class="content-wrapper"
                >
                    <empty-table-message
                        v-if="contagem.data.length < 1"
                        msg="msg-sem-contagem"
                    />
                    <div v-else>
                        <b-table
                            class="data-table itempedido"
                            :data="contagem.data"
                            @sort="sortContagem"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in contagem.fields"
                                :key="i"
                                :field="f.key"
                                :label="$t(f.label)"
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                :numeric="f.numeric"
                                v-slot="props"
                            >
                                <div v-if="f.key === 'produto'">
                                    {{ props.row[f.key] ? props.row[f.key] : "--" }}
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] ? getDecimal(props.row[f.key]) : "--" }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <b-pagination
                            order="is-centered"
                            :total="contagem.totalRows"
                            :current.sync="contagem.currentPage"
                            :per-page="contagem.perPage"
                            @change="carregarContagemItens"
                        />
                    </div>
                </div>
            </div>

            <!-- ABA DE ANEXO -->
            <div
                class="tab-content"
                v-show="abas[abaAtual].label == 'anexo'"
            >
                <div class="content-wrapper">
                    <!-- TABELA DE ANEXOS -->
                    <empty-table-message
                        v-if="anexo.data.length < 1"
                        msg="msg-sem-anexo"
                    />
                    <div v-else>
                        <b-table
                            class="data-table"
                            :data="anexo.data"
                            @sort="sortAnexo"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in anexo.fields"
                                :key="i"
                                :field="f.field"
                                :label="$t(f.key)"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.field == 'datahora'">
                                    {{ props.row[f.field] | moment("L") }}
                                </div>
                                <div v-else-if="f.field == 'nome'">
                                    {{ props.row[f.field] }}
                                </div>
                                <div v-else-if="
                                    f.field == 'caminho' &&
                                    props.row[f.field] &&
                                    ['jpg', 'jpeg', 'png'].includes(
                                        props.row['nome']
                                            .split('.')
                                            [
                                                props.row['nome'].split('.').length - 1
                                            ].toLowerCase()
                                    )"
                                >
                                    <a :href="props.row[f.field]" target="_blank">
                                        <img
                                            :src="props.row[f.field]"
                                            class="img-anexo"
                                            :title="props.row['nome']"
                                            :alt="props.row['nome']"
                                        />
                                    </a>
                                </div>
                                <div v-else>
                                    <a :href="props.row[f.field]" target="_blank">
                                        <img
                                            :src="require('@/assets/img/file.png')"
                                            class="img-anexo"
                                            :title="props.row['nome']"
                                            :alt="props.row['nome']"
                                        />
                                    </a>
                                </div>
                            </b-table-column>
                        </b-table>
                        <b-pagination
                        order="is-centered"
                            :total="anexo.totalRows"
                            :current.sync="anexo.currentPage"
                            :per-page="anexo.perPage"
                            @change="carregarAnexo"
                        />
                    </div>
                </div>
            </div>

            <!-- ABA DE PAGAMENTO -->
            <div
                class="tab-content"
                v-show="abas[abaAtual].label == 'pagamento'"
            >
                <div class="content-wrapper">
                    <empty-table-message
                        v-if="pagamento.data.length < 1"
                        msg="msg-sem-pagamento"
                    />
                    <div v-else>
                        <b-table
                            ref="table_pagamento"
                            class="data-table pagamento"
                            :data="pagamento.data"
                            backend-sorting
                            detailed
                        >

                            <!-- Colunas -->
                            <b-table-column
                                v-for="(f, i) in pagamento.fields"
                                :key="i"
                                :field="f.key"
                                :label="$t(f.key)"
                                :width="f.width"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <span v-if="f.key == 'status-pagamento' " @click="$refs.table_pagamento.toggleDetails(props.row)">
                                    {{ $te(props.row[f.key]) ? $t(props.row[f.key]) : props.row[f.key] }}
                                </span>
                                <span v-else>
                                    {{ $moment(new Date(props.row[f.key])).format("L LTS") }}
                                </span>
                            </b-table-column>

                            <!-- Detalhes da coluna -->
                            <template slot="detail" slot-scope="props">
                                <div v-for="(item, index) in formatJson(props.row['json'])" :key="index">
                                    <span class="is-bold">{{ item.chave }}: </span>
                                    <HideInfo v-if="item.hide" :value="item.valor" :hideInfo="hide.hideInfo" :infoIsHidden="hide.infoIsHidden" />
                                    <span v-else>{{ item.valor }}</span>
                                </div>
                            </template>
                        </b-table>

                        <!-- Paginação -->
                        <b-pagination
                            order="is-centered"
                            :total="pagamento.totalRows"
                            :current.sync="pagamento.currentPage"
                            :per-page="pagamento.perPage"
                            @change="carregarAbaPagamento"
                        />
                    </div>
                </div>
            </div>

            <!-- ABA DE LOGS INTEGRAÇÃO ERP -->
            <div
                class="tab-content is-flex-wrap aba-integracao"
                v-show="abas[abaAtual].label == 'logs-integracao-erp'"
            >
                <div class="columns is-full">
                    <div class="column is-three-quarters logs-integracao-header">
                        <div class="logs-integracao-search-bar">
                            <search-bar
                                :onSearch="logs_integracao.debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-logs-integracao" 
                            />
                        </div>
                    </div>

                    <div class="column is-one-quarter logs-integracao-header">
                        <div class="log-integracao-buttons is-full">
                            <button
                                class="save-btn botao-acao"
                                type="button"
                                @click="confirmDeleteLogs"
                            >
                                {{ $t("deletar-logs-cliente") }}
                            </button>
                        </div>
                    </div>

                </div>

                <div class="column columns is-full item-with-grow is-flex-wrap" >
                    <div
                        class="column is-paddingless is-full registry-wrapper"
                    >   
                        <empty-table-message
                            v-if="logs_integracao.data.length < 1"
                            msg="msg-sem-logs-integracao"
                        />
                        <div v-else>
                            <b-table
                                class="data-table logs_integracao"
                                :data="logs_integracao.data"
                                @sort="sortLogsIntegracao"
                                backend-sorting
                            >
                                <b-table-column
                                    v-for="(f, i) in logs_integracao.fields"
                                    :key="i"
                                    :field="f.key"
                                    :width="f.width"
                                    :label="$t(f.key)"
                                    :sortable="f.sortable"
                                    v-slot="props"
                                >
                                    <div v-if="f.key == 'data-hora'">
                                        {{ props.row[f.key] | moment("L LT") }}
                                    </div>
                                    <!-- MOSTAR OU ESCONDER O TEXTO EM MENSAGEM DE ERRO -->
                                    <div v-else-if="f.key == 'mensagem'">
                                        <span v-if="props.row[f.key].length < logs_integracao.cutIn">{{ props.row[f.key] }}</span>
                                        <b-collapse 
                                            :open="false" 
                                            position="is-bottom" 
                                            aria-id="mensagem" 
                                            v-else-if="props.row[f.key].length >= logs_integracao.cutIn"
                                        >
                                            <template #trigger="showText">
                                                <span v-if="!showText.open">
                                                    <small>{{ verifyText(props.row[f.key]) }}</small>
                                                </span>
                                                <a aria-controls="mensagem">
                                                    <small>{{ !showText.open ? $t("mostrar") : $t("esconder") }}</small>
                                                </a>
                                            </template>
                                            <p class="force-break"><small>{{ props.row[f.key] }}</small></p>
                                        </b-collapse>
                                    </div>
                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </b-table-column>
                            </b-table>
                            <PaginationViewer
                                class="mb-0"
                                :resetPagination="logs_integracao.resetPagination"
                                :totalItems="logs_integracao.totalRows"
                                :perPageOptions="logs_integracao.perPageOptions"
                                :optionStarted="logs_integracao.optionStarted"
                                @change="updateLogsIntegracaoPagination"
                            />
                        </div>
                    </div>

                </div>
            </div>
            <!-- ABA DE LOGS INTEGRAÇÃO SYNC -->
            <LogIntegracaoSync
                v-show="abas[abaAtual].label == 'logs-integracao-sync'"
                :permissao="permissao"
                :pedido="pedido"
            />
            <b-modal :active.sync="isCheckModalOpen">
                <div class="modal-card" v-if="pedido.checks">
                    <header class="modal-card-head">
                        <p class="title is-marginless is-paddingless">
                            {{ $t("fotos-check-in-out") }}
                        </p>
                    </header>
                    <section class="modal-card-body">
                        <div class="columns">
                            <div
                                class="column is-half pic-wrapper"
                                v-for="(p, i) in pedido.checks.documentos"
                                :key="i"
                            >
                                <span
                                    >{{ $t(getLabel(p)) }}:
                                    {{ p.datahora | moment("L LT") }}</span
                                >
                                <img
                                    :src="p.url_documento"
                                    @click="openPicture(p.url_documento)"
                                    alt=""
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </b-modal>
            <b-modal :active.sync="isImageAssinaturaModalActive" width="25%">
                <div class="card">
                    <div class="card-image">
                        <figure class="image">
                            <img :src="assinatura.url_documento" />
                        </figure>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import EmptyTable from "@/components/vendas/EmptyTable";
import PedidoService from "@/services/PedidoService";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";
import PedidoTable from "@/components/vendas/pedido/pedido-table/PedidoTable";
import PedidoRetornoTable from "@/components/vendas/pedido/pedido-table/PedidoRetornoTable"

import MotivoService from "@/services/agro/MotivoService.js";
import ParametrizacaoService from "@/services/ParametrizacaoService";
import LogIntegracaoService from "@/services/LogIntegracaoService";
import ExportacaoService from "@/services/ExportacaoService";
import ExportacaoDadosService from "@/services/ExportacaoDadosService";
import LogIntegracaoSync from "@/components/vendas/pedido/abas/LogIntegracaoSync.vue"
import Itens from "@/components/vendas/pedido/abas/Itens.vue"
import StatusWf from "@/components/vendas/pedido/abas/StatusWf.vue"
import VerifiedLable from "@/components/shared/VerifiedLable.vue";

export default {
    components: {
        EmptyTable,
        HideInfo,
        PedidoTable,
        PedidoRetornoTable,
        LogIntegracaoSync,
        Itens,
        StatusWf,
        VerifiedLable
    },
    data() {
        return {
            abas: [
                { label: "itens", loaded: true },
                { label: "status-wf", loaded: false},
                { label: "contagem", loaded: false },
                { label: "anexo", loaded: false},
                { label: "logs-integracao-erp", loaded: false},
                { label: "logs-integracao-sync", loaded: false},
            ],
            service: new PedidoService(this.$http, this.$router),
            serviceParametrizacao: new ParametrizacaoService(this.$http, this.$router),
            serviceLogIntegracao: new LogIntegracaoService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            paramListaClientePedido: {},
            abaAtual: 0,
            isLoading: true,
            loadingComplete: false,
            pedido: {
                idpedido: null,
                idpedidosovis: null,
                idpedidosovisInt: null,
            },
            pedidoVinculado: null,
            assinatura: {},
            isImageAssinaturaModalActive: false,
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            column: "produto",
            order: "asc",
            contagem: {
                loading: false,
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                column: "produto",
                order: "asc",
                fields: [
                    { key: "produto", label: "produto", sortable: true },
                    {
                        key: "qtdegondola",
                        label: "qtde-gondola",
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: "qtdeestoque",
                        label: "qtde-estoque",
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: "qtdetroca",
                        label: "qtde-troca",
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: "sugestaovenda",
                        label: "sugestao-venda",
                        width: 160,
                        sortable: true,
                        numeric: true,
                    },
                    {
                        key: "qtdeVendido",
                        label: "qtde-vendido",
                        width: 120,
                        sortable: true,
                        numeric: true,
                    },
                ],
                data: []
            },
            pagamento: {
                loading: false,
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                fields: [
                    { key: 'data-hora', sortable: false },
                    { key: 'status-pagamento', sortable: false }
                ],
                data: [],
            },
            // @85328
            anexo: {
                loading: false,
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                fields: [
                    { key: 'arquivo', field: "caminho", sortable: false },
                    { key: 'nome-anexo-pedido', field: "nome", sortable: true },
                    { key: 'datahora-anexo-pedido', field: "datahora", sortable: true },
                ],
                data: [],
                column: "arquivo",
                order: "asc",
            },
            // @86382
            logs_integracao: {
                queryFilter: "",
                debouncedOnSearch: null,
                loading: false,
                currentPage: 1,
                perPage: null,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                cutIn: 40,
                column: 'datahora',
                order: 'desc',
                totalRows: 0,
                fields: [
                    { key: 'codigo', width: 150, sortable: false },
                    { key: 'data-hora', width: 200, sortable: true },
                    { key: 'acao', width: 200, sortable: true },
                    { key: 'mensagem', width: null, sortable: true }
                ],
                data: [],
                isLoading: false,
                resetPagination: false
            },
            isCheckModalOpen: false,
            permissao: {},
            // @84601 - Se o status tiver 'N', 'AP', 'F', 'A', 'C' ou 'D' o mesmo pode alterar o status.
            // @86382 - Adicionado para que se o status estiver como EI, seja possivel alterar o status do pedido.
            isEditSituacao: false,
            statusPermiteEdit: ["N", "AP", "F", "A", "C", "EI"],
            listStatusPedido: [],
            listMotivo: [],
            motivo: null,
            status: null,
            statusLoading: false,
            motivoLoading: false,
            msgs: [],
            //@85171 - variáveis para armazenar os tipos de retorno da cielo
            tiposProdutos: {
                1: "material-fisico",
                2: "digital",
                3: "servico",
                4: "pagamento",
                5: "recorrencia"
            },
            pagamentoStatus: {
                1: "pendente",
                2: "pago",
                3: "negado",
                4: "expiratado",
                5: "cancelado",
                6: "nao-finalizado",
                7: "autorizado",
                8: "chargeback"
            },
            metodoPagamento: {
                1: "cartao-credito",
                2: "boleto-bancario",
                3: "debito-online",
                4: "cartao-debito",
                5: "qrcode",
                6: "pix"
            },
            metodoPagamentoBandeira: {
                1: "visa",
                2: "master",
                3: "american-express",
                4: "diners",
                5: "elo",
                6: "aura",
                7: "jcb",
                8: "discover",
                9: "hipercard"
            },
            metodoPagamentoBanco: {
                1: "banco-brasil",
                2: "bradesco"
            },
            tipoEnvio: {
                1: "correios",
                2: "frete-fixo",
                3: "frete-gratis",
                4: "retirar-em-maos",
                5: "sem-cobranca-frete"
            },
            tipoExportacao: "pdf",
            isShowingTitle: false,
            tituloExportacao: "",
            isSaving: false,
            isExporting: false,
            tipoAutorizacaoList: [],
            tipoAutorizacaoLoading: false,
            tipoAutorizacaoSelected: null,
            motivoAutorizacaoList: [],
            motivoAutorizacaoLoading: false,
            motivoAutorizacaoSelected: null,
            pedidosVinculadoAEssePedido: [],
            pedidosVinculadoAEssePedidoSelected: null,
            pedidosVinculadoAEssePedidoLoading: false,
            bolRetorno: false,
            currentWorkflow: null
        };
    },
    created() {
        this.onPageLoad()
    },
    watch: {
        tipoAutorizacaoSelected(currentTipoAutorizacao) {
            this.loadStatusPedido(currentTipoAutorizacao.id);
        },
        $route: {
            handler() {
                if (this.pedido.id != this.$route.params.id)
                    this.onPageLoad()
            },
            deep: true
        },
    },
    computed: {
        title() {
            if (this.pedido && !this.isNull(this.pedido.idpedido)) {
                const idpedidoerp = "0";
                const idpedidousuario = "1";
                let id = this.pedido.idpedido;
                if (this.paramListaClientePedido && this.paramListaClientePedido.valor == idpedidoerp) {
                    id = this.pedido.idpedidoerp;
                } else if (this.paramListaClientePedido && this.paramListaClientePedido.valor == idpedidousuario) {
                    id = this.pedido.codigo;
                }
                if (this.pedido.cliente) {
                    return `${ id } - ${ this.pedido.cliente.rsocial }`;
                }
                return id;
            }
            return "";
        },
        ...mapState(["hide"]),
    },
    methods: {
        setTipoAutorizacaoSelected(newValue) {
            this.tipoAutorizacaoSelected = newValue;

            if(
                this.tipoAutorizacaoSelected.id > 1 &&
                !this.motivoAutorizacaoSelected &&
                this.motivoAutorizacaoList.length === 1
            )
                this.motivoAutorizacaoSelected = this.motivoAutorizacaoList.at(0);
        },
        getIconSituacaoPedidoVinculado(autorizacaoSituacao) {
            if(autorizacaoSituacao === 1) return {
                icone: "fas fa-exclamation",
                cor: 'yellow'
            };

            if(autorizacaoSituacao === 2) return {
                icone: "fas fa-check",
                cor: 'green'
            };

            return {
                icone: "fas fa-xmark",
                cor: 'red'
            };
        },
        loadPedidosVinculado(uuid) {
            this.pedidosVinculadoAEssePedidoLoading = true;

            this.$axios.get(`/vendas/pedido-vinculado/uuid/${uuid}.json`)
                .then((r) => {
                    if (r.data.status != 200) {
                        this.$root.showMessage("error", "pedido-erro");

                        return;
                    }

                    this.pedidosVinculadoAEssePedido = r.data.content
                        .map(({idpedido: id, idpedidoerp: label, autorizacaoSituacao}) => {
                            const icon = this.getIconSituacaoPedidoVinculado(autorizacaoSituacao);

                            return {
                                id,
                                label,
                                ...icon
                            }
                        });

                    if(this.pedidosVinculadoAEssePedido.length > 0)
                        this.pedidosVinculadoAEssePedidoSelected = this.pedidosVinculadoAEssePedido.at(0);
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-erro");
                })
                .finally((_) => {
                    this.pedidosVinculadoAEssePedidoLoading = false;
                })
        },
        goToPedidoVinculado(idPedidoVinculado) {
            this.$router.push({
                name: 'ven-pedido-edit',
                params: {
                    id: idPedidoVinculado,
                    origem: this.$route.params.origem
                }
            });
        },
        loadPedidoVinculado(uuid) {
            this.$axios.get(`/vendas/pedido/uuid/${uuid}.json`)
                .then((r) => {
                    if (r.data.status != 200) {
                        this.$root.showMessage("error", "pedido-erro");
                        return;
                    } 
                    
                    this.pedidoVinculado = r.data.content;
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-erro");
                })
        },
        isPedidoAutorizacaoValid() {
            let isValid = true;

            if (this.isNull(this.tipoAutorizacaoSelected)) {
                this.$refs.tipoAutorizacaoSelect.focusedOut = true;
                isValid = false;
            }
    
            if (this.isNull(this.motivoAutorizacaoSelected) && this.$refs.motivoAutorizacaoSelect.required) {
                this.$refs.motivoAutorizacaoSelect.focusedOut = true;
                isValid = false;
            }
            
            if (this.isNull(this.pedido.motivoAprovacaoObs) && this.$refs.motivoAprovacaoObsInput.required) {
                this.$refs.motivoAprovacaoObsInput.focusedOut = true;
                isValid = false;
            }
    
            if(this.isNull(this.status)) {
                this.$refs.statusSelect.focusedOut = true;
                isValid = false;
            }

            return isValid;
        },
        getPercentPedidoVinculado(idPedido) {
            this.$axios.get(`/vendas/pedido/${idPedido}/porcentagem-pedido-vinculado.json`)
                .then((r) => {
                    if (r.data.status != 200) {
                        this.$root.showMessage("error", "pedido-erro");
                        return;
                    } 
                    
                    this.$root.confirm({
                        message: this.$t(
                            'pedido-representa-n-pedido-vinculado', 
                            { n: this.parseAsPercent(r.data.content) }
                        ),
                        onConfirm: (_) => this.save(),
                    });
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-erro");
                })
        },
        saveOrInformPercent() {
            if(!this.isPedidoAutorizacaoValid()) {
                this.$root.showMessage("alert", "msg-campos-obrigatorios");

                return;
            }

            if(this.pedido.tipo === 'B' && this.tipoAutorizacaoSelected.id === 2 && !this.isNull(this.pedido.uuidPedidoVinculado)) 
                return this.getPercentPedidoVinculado(this.pedido.idpedido);

            if(
                this.pedidosVinculadoAEssePedido.length > 0 
                && (this.tipoAutorizacaoSelected.id == 3 || this.tipoAutorizacaoSelected.id == 4)
            ) {
                return this.$root.confirm({
                    message: this.$t('msg-aprova-bonificacao'),
                    onConfirm: (_) => this.save(),
                });
            }

            return this.save();
        },
        onPageLoad() {
            this.pedidoVinculado = null
            this.logs_integracao.perPage =
            this.logs_integracao.perPageOptions[this.logs_integracao.optionStarted];

            this.logs_integracao.debouncedOnSearch = this.debounce(this.onSearchLogs, 500);

            this.$route.params.origem = this.$route.params.origem;
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "vendas",
                "ven-pedido"
            );

            !this.permissao.read &&
                this.$router.push({
                    name: "acesso-nao-permitido",
                    params: { tela: "pedidos" },
                });

            this.serviceParametrizacao
                .getConfigByNomeIdusuario("LISTACLIENTEPEDIDO", 0)
                .then((result) => {
                    this.paramListaClientePedido = result.content || { valor: null };
                })
                .finally(() => {
                    this.loadPedido();
                });
        },
        loadTipoAutorizacao() {
            this.tipoAutorizacaoLoading = true;

            this.$axios.get('/vendas/pedido/tipo-autorizacao.json')
                .then((r) => {
                    if (r.data.status != 200) {
                        this.$root.showMessage("error", "pedido-erro");
                        return;
                    } 
                    
                    this.tipoAutorizacaoList = r.data.content
                        .map(({id, descricao: label, obrigaMotivo}) => ({id, label, obrigaMotivo}));

                    this.tipoAutorizacaoSelected = 
                        this.tipoAutorizacaoList.find(({id}) => id === this.pedido.autorizacaoSituacao);

                    this.tipoAutorizacaoList = this.tipoAutorizacaoList.filter(({id}) => id != 0 && id != 1);
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-erro");
                })
                .finally((_) => {
                    this.tipoAutorizacaoLoading = false;
                });
        },
        loadMotivoAutorizacao() {
            this.motivoAutorizacaoLoading = true;
            this.motivoService
                .findAll("motivo", "desc", 0, 10000, 1, [
                    ".*",
                    "PEDIDO_AUTORIZACAO",
                ])
                .then((response) => {
                    this.motivoAutorizacaoList = response.content
                        .map(({id, descricao: label, habilitaobrigaobservacao}) => ({id, label, habilitaobrigaobservacao}));

                    this.motivoAutorizacaoSelected = 
                        this.motivoAutorizacaoList.find(({id}) => id === this.pedido.idMotivoAprovacao);

                    if(
                        this.pedido.autorizacaoSituacao > 1 &&
                        !this.motivoAutorizacaoSelected &&
                        this.motivoAutorizacaoList.length === 1
                    )
                        this.motivoAutorizacaoSelected = this.motivoAutorizacaoList.at(0);
                })
                .catch(() => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally(() => {
                    this.motivoAutorizacaoLoading = false;
                });
        },
        loadPedido(){
            this.isLoading = false;

            if (this.$route.params.origem == 'interno') {
                this.carregarDadosPedido();
            } else {
                this.carregarDadosPedidoRetorno();
            }
        },
        carregarDadosPedido() {
            this.isLoading = true;
            this.$axios.get(`/vendas/pedido/${this.$route.params.id}.json`)
                .then((r) => {
                    if (r.data.status != 200) {
                        this.$root.showMessage("error", "pedido-erro");
                    } else {
                        this.pedido = r.data.content;
                        
                        // @85171 - se possuir link de pagamento, exibe a aba de pagamento!
                        if (this.pedido.linkPagamento) {
                            this.abas.push({ label: 'pagamento', loaded: false });
                        }
                        // @85171 - se conter algumas dessas situações pode editar a mesma.
                        this.isEditSituacao = this.statusPermiteEdit.includes(
                            this.pedido.registro_enviado
                        ) && this.pedido.autorizacaoSituacao === 1;
                        this.pedido.valortotal = r.data.content.valortotal;

                        if (r.data.content.motivo) {
                            this.listMotivo = [
                                {
                                    value: r.data.content.motivo.descricao,
                                },
                            ];
                            this.motivo = r.data.content.motivo.descricao;
                        }
                        
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", "pedido-erro");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.loadingComplete = true;
                    this.carregarAssinaturas();
                    this.loadStatusPedido();
                    this.loadTipoAutorizacao();
                    this.loadMotivoAutorizacao();
                    
                    if(!this.isNull(this.pedido.uuidPedidoVinculado)) 
                        this.loadPedidoVinculado(this.pedido.uuidPedidoVinculado);

                    this.loadPedidosVinculado(this.pedido.uuid);
                });
        },
        carregarAssinaturas() {
            this.isLoading = true;
            this.service.getSignature(this.pedido.idpedido)
                .then((r) => {
                    if (r.status != 200) {
                        this.$root.showMessage(
                            "error",
                            "pedido-assinatura-erro"
                        );
                    } else {
                        let assinaturas = r.content;
                        if (assinaturas && assinaturas.length) {
                            this.assinatura = assinaturas[0];
                        }
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", "pedido-assinatura-erro");
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        carregarDadosPedidoRetorno() {
            this.isLoading = true;
            this.$axios
                .get(`/vendas/pedido/return/${this.$route.params.id}.json`)
                .then((r) => {
                    if (r.data.status != 200) {
                        this.$root.showMessage("error", "pedido-erro");
                    } else {
                        this.bolRetorno = true;
                        this.pedido = r.data.content;
                        this.status = {
                            id: 0,
                            label: this.getStatus(this.pedido.registro_enviado)
                        };
                    }
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-erro");
                })
                .finally((_) => {
                    this.carregarAssinaturas();
                    this.isLoading = false;
                    this.loadingComplete = true;
                });
        },
        carregarContagemItens(page) {
            this.contagem.loading = true;
            const pageNum = page > 0 ? page - 1 : 0;
            this.$axios
                .get(`/vendas/pedido/${this.pedido.idpedido}/count.json`, {
                    params: {
                        page: pageNum,
                        limit: this.contagem.perPage,
                        order: this.contagem.order,
                        column: this.contagem.column,
                        idpedidosovis: this.pedido.idpedidosovis || null
                    }
                })
                .then((response) => {
                    if (response.data.status != 200) {
                        this.$root.showMessage("error", "pedido-detalhes-erro");
                    } else {
                        this.contagem.totalRows = response.data.totalElements;
                        this.contagem.data = response.data.content;
                    }
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-detalhes-erro");
                })
                .finally(() => {
                    this.contagem.loading = false;
                });
        },

        // @85328 - Carrega os anexos do pedido
        carregarAnexo(page){
            this.anexo.loading = true;
            const pageNum = page > 0 ? page - 1 : 0;
            this.$axios
                .get(`/pedido/${this.pedido.idpedido}/attachment.json`, {
                    params: {
                        page: pageNum,
                        limit: this.anexo.perPage,
                        order: this.anexo.order,
                        column: this.anexo.column,
                        idpedidosovis: this.pedido.idpedidosovis || null
                    }
                })
                .then((response) => {
                    if (response.data.status != 200) {
                        this.$root.showMessage("error", "pedido-anexo-erro");
                    } else {
                        this.anexo.totalRows = response.data.totalElements;
                        this.anexo.data = response.data.content;
                    }
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-anexo-erro");
                })
                .finally(() => {
                    this.isLoading = false;
                    this.anexo.loading = false;
                });
        },
        /**
         * Carrega os pagamentos do pedido
         */
        carregarAbaPagamento(page) {
            this.pagamento.loading = true;

            this.$axios
                .get(`/cielo/status/pagamento.json`, {
                    params: {
                        page: page > 0 ? page - 1 : 0,
                        limit: this.pagamento.perPage,
                        uuidPedido: this.pedido.uuid
                    }
                })
                .then((r) => {
                    if (r.status != 200) {
                        this.$root.showMessage("error", "pedido-detalhes-erro");
                    } else {
                        this.pagamento.totalRows = r.totalElements;
                        this.pagamento.data = r.content.map((e) => ({
                            'data-hora': e.datahorainc,
                            'status-pagamento': e.statusinsercao,
                            'json': e.jsonResponse
                        }));
                    }
                })
                .catch(() => {
                    this.$root.showMessage("error", "pedido-detalhes-erro");
                })
                .finally((_) => {
                    this.pagamento.loading = false;
                });
        },
        /**
         * @86382
         * Carrega os Logs da integração com o ERP
         */
        carregarAbaLogsIntegracao(page) {
            this.logs_integracao.loading = true;
            this.$axios.get(`/ven/apiauditoria/logs-entidade.json`, {
                params: {
                    page: page > 0 ? page - 1 : 0,
                    limit: this.logs_integracao.perPage,
                    order: this.logs_integracao.order,
                    column: this.logs_integracao.column,
                    idregistro: this.pedido.idpedidosovisInt || this.pedido.idpedido,
                    entidade: "PEDIDO",
                    params: this.logs_integracao.queryFilter
                }
            })
            .then((response) => {
                if (response.data.status != 200) {
                    this.$root.showMessage("error", "pedido-detalhes-erro");
                } else {
                    this.logs_integracao.totalRows = response.data.totalElements;
                    this.logs_integracao.data = response.data.content.map((e) => ({
                        'codigo': e.idAuditoria,
                        'data-hora': e.datahora,
                        'acao': this.getAcaoFullName(e.acao),
                        'mensagem': e.mensagemErro
                    }));
                }
            })
            .catch(() => {
                this.$root.showMessage("error", "pedido-detalhes-erro");
            })
            .finally(() => {
                this.logs_integracao.loading = false;
            });
        },
        /**
         * @86382
         * Altera a ação para o texto completo correspondente ao log usado.
         */
        getAcaoFullName( acao ){
            switch (acao){
                case "I":
                    return this.$t("auditoria-insercao").toUpperCase();
                case "U":
                    return this.$t("auditoria-update").toUpperCase();
                case "D":
                    return this.$t("auditoria-delete").toUpperCase();
                default:
                    return this.$t("sem-acao"); // caso log não tenha uma acao, exibe Sem Acao
            }
        },
        /**
         * @86382
         */
        sortLogsIntegracao(field, order) {
            this.logs_integracao.column = field;
            this.logs_integracao.order = order;
            this.carregarAbaLogsIntegracao(this.logs_integracao.currentPage);
        },
        loadStatusPedido(autorizacaoSituacao = 0) {
            this.statusLoading = true;
            this.service.getStatusPedidoComboEdit(
                this.pedido.idVenPedidoSituacao, 
                autorizacaoSituacao, 
                this.$route.params.origem != 'interno'
            )
                .then((response) => {
                    if (response.status == 200 && response.content) {
                        this.listStatusPedido = response.content.map((status) => {
                            return {
                                'id': status.id,
                                'label': status.titulo,
                                'sigla': status.sigla
                            }
                        });
                        this.status = this.listStatusPedido.find(status=>status.id == this.pedido.idVenPedidoSituacao);

                        if(!this.status && this.listStatusPedido.length === 1)
                            this.status = this.listStatusPedido.at(0);
                    }
                })
                .catch(() => {
                    this.listStatusPedido = [];
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally(() => {
                    this.statusLoading = false;
                });
        },
        changeTab(i) {
            this.abaAtual = i;

            if (!this.abas[i].loaded) {
                switch (this.abas[i].label) {
                    case "contagem":
                        this.contagem.currentPage = 1;
                        this.carregarContagemItens(1);
                        this.abas[i].loaded = true;
                        break;
                    case "pagamento":
                        this.pagamento.currentPage = 1;
                        this.carregarAbaPagamento(1);
                        this.abas[i].loaded = true;
                        break;
                    case "anexo":
                        this.anexo.currentPage = 1;
                        this.carregarAnexo(1);
                        this.abas[i].loaded = true;
                        break;
                    case "logs-integracao-erp":
                        this.logs_integracao.currentPage = 1;
                        this.carregarAbaLogsIntegracao(1);
                        this.abas[i].loaded = true;
                        break;
                    case "logs-integracao-sync":
                        this.abas[i].loaded = true;
                        break;
                    case "status-wf":
                        this.abas[i].loaded = true;
                        break;
                    default:
                        console.error("[PEDIDO] Aba inválida.");
                        break;
                }
            }
        },
        sortContagem(field, order) {
            this.contagem.column = field;
            this.contagem.order = order;
            this.carregarContagemItens(this.contagem.currentPage);
        },
        // @85328
        sortAnexo(field, order) {
            this.anexo.column = field;
            this.anexo.order = order;
            this.carregarAnexo(this.anexo.currentPage);
        },
        // @85328
        showMessageAnexo(data) {
            this.$root.showMessage("alert", data);
        },
        openCheckPhotoModal(type) {
            if (
                type == "out" &&
                this.pedido.checks.documentos &&
                this.pedido.checks.documentos.findIndex(
                    (e) => e.datahora == this.pedido.checks.checkoutdatahora
                ) > -1
            ) {
                this.isCheckModalOpen = true;
            } else if (
                type == "in" &&
                this.pedido.checks.documentos &&
                this.pedido.checks.documentos.findIndex(
                    (e) => e.datahora == this.pedido.checks.checkindatahora
                ) > -1
            ) {
                this.isCheckModalOpen = true;
            }
        },
        openPicture(url) {
            window.open(url, "_blank");
        },
        getLabel(d) {
            if (d.datahora == this.pedido.checks.checkindatahora) {
                return "check-in";
            } else if (d.datahora == this.pedido.checks.checkoutdatahora) {
                return "check-out";
            } else {
                return "data";
            }
        },
        getStatus(status) {
            switch (status) {
                case "E":
                    return this.$t("processando").toUpperCase();
                case "S":
                    return this.$t("transmitido").toUpperCase();
                case "N":
                    return this.$t("nao-enviado").toUpperCase();
                case "C":
                    return this.$t("cancelado").toUpperCase();
                case "A":
                    return this.$t("aprovado").toUpperCase();
                case "F":
                    return this.$t("faturado").toUpperCase();
                case "AP":
                    return this.$t("aguardando-aprovacao").toUpperCase();
                case "ED":
                    return this.$t("em-edicao").toUpperCase();
                case "D":
                    return this.$t("deletado").toUpperCase();
                case "EI":
                    return this.$t("problema-integracao-erp").toUpperCase();
                default:
                    return status === "sem-status"
                        ? this.$t(status).toUpperCase()
                        : status.toUpperCase(); //@84601 - caso pedido retorno não tenha um statuswf, exibe Sem Status
            }
        },
        save() {
            this.isLoading = true;

            const pedidoToSave = {
                idpedido: this.pedido.idpedido,
                uuidPedidoVinculado: this.pedido.uuidPedidoVinculado,
                autorizacaoSituacao: this.tipoAutorizacaoSelected.id,
                idMotivoAprovacao: this.motivoAutorizacaoSelected ? this.motivoAutorizacaoSelected.id : null,
                motivoAprovacaoObs: this.pedido.motivoAprovacaoObs,
                uuid: this.pedido.uuid,
                clientenovo: this.pedido.clientenovo,
                idusuario: this.pedido.idusuario,
                venPedidoSituacao: {
                    id: this.status.id,
                    descricao: this.status.label,
                    sigla: this.status.sigla
                }
            }

            this.service.save(pedidoToSave)
            .then((value) => {
                if (value.message == null) {
                    this.msgs.push(new Message("success", 'status-pedido-alterado-sucesso', true));

                    if(!this.isNull(this.pedidoVinculado) && pedidoToSave.autorizacaoSituacao === 4) {
                        this.$root.confirm({
                            message: this.$t('pedido-aprovado-redirecionar-pedido-vinculado'),
                            onConfirm: (_) => this.goToPedidoVinculado(this.pedidoVinculado.idpedido),
                        });
                    }

                    this.loadPedido();
                } else if (value.status === 403 && value.content) {
                    this.$root.confirm({
                        message: this.$t(value.message),
                        onConfirm: (_) => this.$router.push({
                            name: 'ven-pedido-edit',
                            params: {
                                id: value.content.idpedido,
                                origem: this.$route.params.origem,
                            }
                        }),
                    });
                } else {
                    if (this.$t(value.message)) {
                        this.msgs.push(
                            new Message("alert", value.message, true)
                        );
                    } else {
                        this.msgs.push(
                            new Message(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            )
                        );
                    }
                }
            })
            .catch((e) => {
                if (e.body.status == 500) {
                    this.msgs.push(
                        new Message("alert", e.body.message, true)
                    );
                } else if(e.body.status == 403) {
                    this.$root.confirm({
                        message: this.$t(e.body.message),
                        onConfirm: (_) => this.$router.push({
                            name: 'ven-pedido-edit',
                            params: {
                                id: e.body.response.idpedido
                            }
                        }),
                    });
                }
                else {
                    this.msgs.push(
                        new Message("error", "msg-erro-salvar", true)
                    );
                }
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        // Pega o json e cria as chaves e valores formatados para html
        formatJson(json) {
            // retorno
            let response = [];
            
            // chaves que deve conter a opção de esconder o conteúdo.
            let camposHide = [
                'order_number', 'checkout_cielo_order_number', 'customer_name', 'customer_phone',
                'customer_email', 'customer_identity', 'tid', 'product_id'
            ];

            // formatando a string para json
            let jsonFormat = JSON.parse(json);

            Object.keys(jsonFormat).forEach((key) => {
                let chave = this.$te(key) ? this.$t(key) : key;
                // no caso esse brand é a mesma coisa que o abaixo. (Cartão da Bandeira)
                if (chave == "brand") {
                    chave = this.$t('payment_method_brand');
                }

                let result;

                /**
                 * @85171
                 * 
                 * Esses campos do json retorna um número, exemplo 2, que
                 * tem alguma informção, quando vem esse número eu busco qual
                 * é a informação que será exibida no lugar.
                 */
                switch (key) {
                    case "product_type":
                        result = this.$t(this.tiposProdutos[jsonFormat[key]])
                        break;
                    case "payment_status":
                        result = this.$t(this.pagamentoStatus[jsonFormat[key]])
                        break;
                    case "payment_method_type":
                        result = this.$t(this.metodoPagamento[jsonFormat[key]])
                        break;
                    case "payment_method_brand":
                        result = this.$t(this.metodoPagamentoBandeira[jsonFormat[key]])
                        break;
                    case "payment_method_bank":
                        result = this.$t(this.metodoPagamentoBanco[jsonFormat[key]])
                        break;
                    case "shipping_type":
                        result = this.$t(this.tipoEnvio[jsonFormat[key]])
                        break;
                    default:
                        result = jsonFormat[key][0];
                        break;
                }

                let objRetorno = {
                    "chave": chave,
                    "valor": result
                };

                if (camposHide.includes(key)) {
                    objRetorno["hide"] = true;
                }

                response.push(objRetorno);
            });

            return response;
        },
        /**
         * @86382
         * Funções de remoção dos logs de implantação com o ERP
         */
        confirmDeleteLogs() {
            this.situacaoAcao = 1;
            this.$root.confirm({
                message: this.$t("msg-confirmacao-delecao-logs-integracao"),
                onConfirm: this.deleteAllLogsFromEntidade,
                onCancel: (_) => {
                },
            });
        },
        deleteAllLogsFromEntidade(){
            this.logs_integracao.isLoading = true;

            this.serviceLogIntegracao
                .deleteVendas(
                    "PEDIDO",
                    this.pedido.idpedido
                )
                .then((r) => {
                    if (r.status != 200) {
                        this.$root.showMessage("error", "delecao-logs-integracao-erro");
                    } else {
                        this.carregarAbaLogsIntegracao(1);
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", "delecao-logs-integracao-erro");
                })
                .finally((_) => {
                    this.logs_integracao.isLoading = false;
                });
        },
        updateLogsIntegracaoPagination(value) {
            this.logs_integracao.resetPagination = false;
            this.logs_integracao.perPage = value.perPage;
            this.logs_integracao.currentPage = value.currentPage;
            this.carregarAbaLogsIntegracao(value.currentPage);
        },
        onSearchLogs(value) {
            this.logs_integracao.queryFilter = this.removeAcentos(value);
            this.logs_integracao.currentPage = 1;
            this.carregarAbaLogsIntegracao();
        },
        verifyText(str){
            if(str.length>this.logs_integracao.cutIn)
                str = str.substring(0,this.logs_integracao.cutIn)+'...';
            return str;
        },
        saveExportacao() {
            if(this.isNull(this.pedido)){
                this.$root.showMessage('alert', "msg-valida-dados");
            }else{
                this.isExporting = true;
                this.isShowingTitle = false;
                this.tituloExportacao = "pedido-" + this.pedido.idpedido + ".pdf";
                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: "EXPORTANDO",
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                };

                if (this.pedido.registro_enviado == "ED") {
                    this.gerarArquivoExportacaoOrcamento(exportacao);
                }else {
                    this.gerarArquivoExportacaoPedido(exportacao);
                }
            }
        },
        gerarArquivoExportacaoPedido(exportacao){
            let exportacaoPedido = {
                exportacao: exportacao,
                usuario: this.$store.state.user,
            };

            //Isso serve para desconsiderar pedidos que não foram tratados corretamente em produção
            const tipoPedidoVazio = ['0', '', ' ', 'null']; 

            let idPedido =
            this.$route.params.origem == 'interno'
                ? this.pedido.idpedido
                : !this.pedido.idpedidosovis || tipoPedidoVazio.includes(this.pedido.idpedidosovis)
                    ? this.pedido.idpedido
                    : this.pedido.idpedidosovis

            this.exportacaoDadosService
                .savePedido(
                    exportacaoPedido,
                    this.tipoExportacao,
                    "P",
                    idPedido,
                )
                .then( value => {
                    if(value.content){
                        this.tituloExportacao = "";
                        this.downloadArchive(value.content);
                    }
                })
                .catch(() => {
                    console.error(
                        "Erro ao salvar exportação",
                        this.tipoExportacao
                    );
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                })
                .finally((_) => {
                    this.isExporting = false;
                });
        },
        gerarArquivoExportacaoOrcamento(exportacao){
            let exportacaoPedido = {
                exportacao: exportacao,
                usuario: this.$store.state.user,
            };

            let uuidPedido = this.pedido.uuid;

            this.exportacaoDadosService
                .saveOrcamento(
                    exportacaoPedido,
                    this.tipoExportacao,
                    "O",
                    uuidPedido,
                )
                .then( value => {
                    if(value.content){
                        this.tituloExportacao = "";
                        this.downloadArchive(value.content);
                    }
                })
                .catch(() => {
                    console.error(
                        "Erro ao salvar exportação",
                        this.tipoExportacao
                    );
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                })
                .finally((_) => {
                    this.isExporting = false;
                });
        },
        downloadArchive(url) {
            //Pega o indice da ultima barra da url
            let n = url.lastIndexOf("/");
            // Pega o texto que fica após a ultima barra, no caso nome do arquivo
            let fileName = url.substring(n + 1);

            this.exportacaoService.downloadArchive(url).then((r) => {
                let blob = new Blob([r.data], { type: this.tipoExportacao });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(blob);
                }, 100);
            });
        },
        getDescricaoStatus(sigla) {
            const mapa = {
                PC: "PEDIDO CRIADO",
                PA: "PEDIDO ALTERADO",
                PT: "PEDIDO TRANSMITIDO",
            };
            return mapa[sigla];
        },
    },
};
</script>

<style lang="scss" scoped>
.container-pedido{
    height: 100%;
}
#main {
    padding: 0 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

.cabecalho {
    position: relative;
    
    .detalhes-pedido {
        padding-top: 1rem;
        color: $darker-gray-color;
        margin-bottom: -0.5rem;

        .detalhes-label {
            font-weight: 600;
        }

        .columns {
            & > .column {
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
            }

            &:last-child {
                margin-bottom: -0.25rem;
            }
        }
    }

    .header-buttons {
        .save-btn {
            height: 43px;
        }
    }
}

.header-buttons {
    .save-btn {
        min-width: 100px;
        height: 43px;
    }
}

.item-tabs { 
    .nav.nav-tabs {
        margin-top: 0;
        margin-bottom: 0;
        margin-left: -20px;
        padding-left: 20px;
        li.active > a {
            color: $primary-color-click;
        }
    }
}

.tab-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .content-wrapper {
        flex-grow: 1;
        position: relative;
    }
}

.is-justify-end-sovis {
    justify-content: flex-end;
    display: flex;
}
.pic-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    font-weight: 600;

    span {
        width: 100%;
        text-align: center;
    }

    img {
        cursor: pointer;
        max-height: 60vh;
    }
}

section.modal-card-body {
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    color: $darker-gray-color;

    .columns {
        justify-content: center;
    }
}

.logs-integracao-search-bar{
    width: 100%;
}

.logs-integracao-header{
    align-self: start;
    .log-integracao-buttons{
        position: relative;
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }
}

.aba-integracao{
    flex-direction: column;
    .item-with-grow{
        flex-grow: 1;
    }
}

.botao-acao{
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

.label-km {
    padding-left: 0;
    padding-right: 0;
}
.bar {
    border-radius: 100px;
    width: 6px;
    height: 27px;
    position: absolute;
    top: -17px;

    &.add-ped {
        background-color: #5f971e;
    }

    &.rem-ped {
        background-color: #a82929;
    }
}
.bar-column {
    padding-left: 0.01rem;
    padding-right: 0.01rem;
}
@media (max-width: 760px) {
    .label-km {
        padding-left: 5px;
        padding-right: 20px;
        justify-content: left;
    }
}

@media (max-width: 760px) {
    .botao-acao {
        margin-top: 0;
    }
}

@media screen and (max-width: 769px), print {
    .page {
        .detalhes-pedido {
            .detalhes-label {
                padding-bottom: 0 !important;

                & + .column {
                    padding-top: 0 !important;
                }
            }
        }
    }
}

.img-anexo {
    height: 48px;
}
.data-table .ml-1 {
    margin-left: 0 !important;
}

}

.gap-3 {
    gap: 16px;
}

.status-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 0.8em;
    background-color: var(--primary-color) !important;
    transition: background-color 0.3s, color 0.3s;
    min-width: 40px;
    flex-shrink: 0;
}
</style>
